import GenericTabs from '../../genericTabs/genericTabs'
import {useDispatch, useSelector} from 'react-redux'
import {setSelectedTab, setViewTabs} from '../../../reducer/strategyBuilder.reducer'
import {selectBasketId, selectStrategyBuilderTab, selectTradeOrders, selectViewTabs} from '../../../selectors/strategyBuilder'
import StrategiesMenu from '../../predefinedStrategies'
import React, {memo, useEffect, useMemo} from 'react'
import {useCombineBasketAnalyzeAndLegOrders} from '../../../hooks/useCombineBasketAnalyzeAndLegOrders'
import {selectBasketAnalyzeDetails} from '../../../selectors/orders'
import OptionChainSettings from '../../optionChain/header/optionChainSettings'
import { OptionChainViewKey } from '../../../assets/constants'
import { Box } from '@mui/material'
import { selectPositions } from '../../../selectors/positions'
import { useUser } from '../../../context/UserContext'
import { FeatureCategory, FeatureName } from '../../adminUserRestrictions/Restrictions.constants'
import { Group, setFeatureRestrictionDialog } from '../../../reducer/user.reducer'

export const enum StrategyBuilderTab {
    Payoff = 'Payoff',
    OptionChain = 'OptionChain',
    StrategyChart = 'StrategyChart'
}

const StrategyBuilderHeader: React.FC<{optionChainViewKey?: OptionChainViewKey}> = ({optionChainViewKey = OptionChainViewKey.LIVE}) => {
    const dispatch = useDispatch()
    const selectedTab = useSelector(selectStrategyBuilderTab)
    const viewTabs = useSelector(selectViewTabs)
    const {orders = []} = useCombineBasketAnalyzeAndLegOrders()
    const tradeOrders =useSelector(selectTradeOrders);
    const basketId = useSelector(selectBasketId);
    const positions = useSelector(selectPositions)
    const {user : {hasAccess}} = useUser();
    const hasStrategyChartAccess = hasAccess(FeatureCategory.STRATEGY_CHART , '' , FeatureName.STRATEGY_CHART_ACCESS)

    const strategyBuilderTabItems = useMemo(() => [
        {
            key: StrategyBuilderTab.Payoff,
            label: 'Payoff',
            disabled: false
        },
        {
            key: StrategyBuilderTab.OptionChain,
            label: 'Option Chain',
            disabled: false
        },
        {
            key: StrategyBuilderTab.StrategyChart,
            label: 'Strategy Chart',
            disabled: false,
            isStrategyChart: true
        },
    ], [hasStrategyChartAccess])

    const basketPositions = useMemo(() => (positions || []).filter(p => p.basketId === basketId), [positions, basketId])
    const basketAnalyzeDetails = useSelector(selectBasketAnalyzeDetails)

    useEffect(() => {
        if ((tradeOrders?.length || basketPositions.length) && !viewTabs) {
            dispatch(setViewTabs(true))
        }
    }, [orders, basketPositions])

    useEffect(()=>{
        if(!hasStrategyChartAccess && selectedTab === StrategyBuilderTab.StrategyChart){
            dispatch(setSelectedTab(StrategyBuilderTab.Payoff))
        }
    },[selectedTab])

    const optionChainTab = useMemo(() => selectedTab === StrategyBuilderTab.OptionChain, [selectedTab])

    return (
        <>
            {!basketAnalyzeDetails && <StrategiesMenu optionChainViewKey={optionChainViewKey} />}
            {viewTabs ? (
                <>
                    <Box id="strategy-builder-tabs">
                        <GenericTabs<StrategyBuilderTab>
                            items={strategyBuilderTabItems}
                            onChange={(val) => {
                                if(val == StrategyBuilderTab.StrategyChart){
                                    if(!hasStrategyChartAccess){
                                        dispatch(setFeatureRestrictionDialog({
                                            open: true,
                                            feature: "Strategy chart",
                                            group: Group.STRATEGY_BUILDER
                                        }))
                                        return
                                    }
                                }
                                if (val) dispatch(setSelectedTab(val))
                            }}
                            value={selectedTab}
                            tabProps={{ sx: { minWidth: 60 } }}
                            sx={{height: 32, marginLeft: 2, marginRight: 2}}
                        />
                    </Box>
                    {optionChainTab && <OptionChainSettings />}
                </>
            ) : null}
        </>
    )
}
export default memo(StrategyBuilderHeader)
